<template>
	<div class="header">
	      <div class="l-wrap">
	        <a class="header__logo" href="https://www.zhaouc.com/" target="_blank">塔人网络</a>
			<!-- <a class="news_nav" href="http://pay.tarenwang.com/" target="_blank">游戏充值</a> -->
			<el-dropdown class="news_nav">
				<span>
					游戏充值
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item><a href="http://pay.tarenwang.com/" target="_blank">MU、SUN</a></el-dropdown-item>
				    <!-- <el-dropdown-item><a href="http://trpay.zhaouc.com/" target="_blank">RO</a></el-dropdown-item> -->
				</el-dropdown-menu>
			</el-dropdown>
			<el-dropdown class="news_nav">
				<span>
					帐号管理
				</span>
				<el-dropdown-menu slot="dropdown">
				    <el-dropdown-item><a href="http://yht.zhaouc.com/" target="_blank">MU、SUN</a></el-dropdown-item>
				    <el-dropdown-item><a href="http://roinfo.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
					<el-dropdown-item><a href="http://my.zhaouc.com/" target="_blank">新一号通</a></el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- <a class="news_nav" href="http://my.zhaouc.com/" target="_blank">帐号管理</a> -->
			<a class="news_nav" href="http://www.zhaouc.com/" target="_blank">塔人主站</a>
			<a class="news_nav" href="/">客服首页</a>
	      </div>
	    </div>
</template>

<script>
	export default {
	    name: "top1",
		data () {
		  return {
		
		  }
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/top1.vue